// src/lib/api.ts
import axios from "axios";
import { getToken, isLoginRemembered, renewLoginIfNeeded } from "./auth";

const ORIGIN = (import.meta.env.VITE_API_BASE || "").replace(/\/$/, "");

// 같은 오리진이면 "/api", 다른 오리진이면 "https://.../api"
const baseURL = ORIGIN ? `${ORIGIN}/api` : "/api";

const api = axios.create({
  baseURL,
  withCredentials: true,
});

const sessionEndpoint = (url = "") => /\/(login|logout|signup|auth\/session(?:\/enable)?)$/.test(url);

api.interceptors.request.use(async (cfg) => {
  const t = sessionEndpoint(cfg.url) ? getToken() : await renewLoginIfNeeded();
  if (t) {
    cfg.headers.set("Authorization", `Bearer ${t}`);
  } else {
    cfg.headers.delete("Authorization");
  }
  return cfg;
});

api.interceptors.response.use(response => response, async error => {
  const cfg = error.config;
  if (error.response?.status !== 401 || !cfg || cfg.__sessionRetried || sessionEndpoint(cfg.url) || !isLoginRemembered()) throw error;
  cfg.__sessionRetried = true;
  const before = getToken();
  const token = await renewLoginIfNeeded(true);
  if (!token || token === before) throw error;
  return api.request(cfg);
});

export default api;
